import { Component, enableProdMode } from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { Map } from '../../models/objects.model';
import {
  Configuration,
  FunctionDesc,
  ElementAction,
  RestServiceAction,
  ParameterAction,
  RowFunction,
  AssemblyAction,
  Action,
  CustomDialogAction,
  RowFunctionFilter
} from '../../models/configuration.model';
import { FunctionService } from '../../services/function/function.service';
import { SearchFilterSortService } from 'ng-searchfiltersort';
import { NotificationService } from '../../services/notification/notification.service';

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

// TODO MK-REF
@Component({
  selector: 'baf-context-menu',
  templateUrl: 'context-menu.component.html',
  styleUrls: ['context-menu.component.css']
})
export class ContextMenuComponent {
  itemsGlobal: { data: FunctionDesc }[] = [];
  itemsStore: ArrayStore;
  itemsSource: DataSource;
  columns: {
    dataField: string;
    caption: string;
    filterOperations: string[];
    selectedFilterOperation: string;
  }[] = [];
  config: Configuration = null;
  elements: HTMLCollectionOf<Element> = null;
  reportsToProceed: number;
  rowFunctions: FunctionDesc[] = [];

  constructor(
    private storeService: DataStoreService,
    private functionService: FunctionService,
    private notifier: NotificationService,
    private sfsService: SearchFilterSortService
  ) {
    this.itemsStore = new ArrayStore();
    this.itemsSource = new DataSource({
      store: this.itemsStore,
      pageSize: 10
    });
    storeService.getCurrentView().subscribe(node => {
      const elementAction = node.action as ElementAction;
      if (!this.config) {
        this.config = this.storeService.getConfiguration();
      }
      if (!elementAction || !elementAction.elementId) {
        return;
      }

      this.rowFunctions = [];
      this.itemsGlobal = [];
      const properElement = this.config.businessModel.elements.find(
        element => element.id.toUpperCase() === elementAction.elementId.toUpperCase()
      );
      if (properElement && properElement.genericElementViews) {
        const properView = properElement.genericElementViews.find(
          element => element.id.toUpperCase() === elementAction.elementViewId.toUpperCase()
        );
        if (properView) {
          this.rowFunctions = this.sfsService.orderBy(properView.rowFunctions, 'order');
          for (const globalFunction of properView.functions) {
            this.itemsGlobal.push({ data: globalFunction });
          }
        }
      }
    });

    storeService.getCurrentRowData().subscribe(rowData => {
      this.itemsStore.clear();
      for (const func of this.rowFunctions) {
        if (this.checkAllowFunction(func)) {
          this.itemsStore.insert({
            id: func.id,
            name: func.displayName.name,
            data: func,
            rowData: rowData
          });
        }
      }
      this.itemsSource.reload();
    });
  }

  private getExpressionFilter(filters: RowFunctionFilter[]) {
    if (!filters || !filters.length) {
      return null;
    }
    let outputFilter = '';
    const pattern = '[FilteringValue]';
    const node = <Map[]>this.storeService.currentRowDataObject;
    for (let i = 0; i < filters.length; i++) {
      if (
        filters[i].filteringField &&
        filters[i].filteringExpression &&
        node[filters[i].filteringField]
      ) {
        if (i > 0) {
          outputFilter += filters[i].prevOperator || ' && ';
        }
        outputFilter +=
          '(' +
          this.replacePattern(
            filters[i].filteringExpression,
            pattern,
            node[filters[i].filteringField]
          ) +
          ')';
      }
    }
    return outputFilter;
  }

  private replacePattern(source: string, oldValue: string, newValue: string): string {
    while (source.indexOf(oldValue) >= 0) {
      source = source.replace(oldValue, newValue);
    }

    return source;
  }

  private checkAllowFunction(func: FunctionDesc): boolean {
    const rowFunction = func as RowFunction;
    const expression = this.getExpressionFilter(rowFunction.filters);
    if (expression) {
      return Function('"use strict";return (' + expression + ')')();
    }
    return this.functionService.checkAllowFunction(func);
  }

  onHidden(e): void {
    this.elements = document.getElementsByClassName('force-hover');
    if (this.elements && this.elements[0]) {
      this.elements[0].classList.remove('force-hover');
    }
  }

  onShowing(e): void {
    this.elements = document.getElementsByClassName('dx-state-hover');
    if (this.elements && this.elements[0]) {
      this.elements[0].classList.add('force-hover');
    }
  }

  onInitialized(e): void {}

  onShown(e): void {}

  onItemClick(e) {
    if (!e.itemData.items) {
      const item = <FunctionDesc>e.itemData.data;
      const action = e.itemData.data.action as Action;
      switch (action.actionType) {
        case 'RestServiceAction':
          const restServiceAction = e.itemData.data.action as RestServiceAction;
          this.functionService.callService(restServiceAction, this.storeService.currentId);
          break;
        case 'ParameterAction':
          const parameterAction = e.itemData.data.action as ParameterAction;
          this.functionService.callParameterized(parameterAction, this.storeService.currentId);
          break;
        case 'CustomAction':
          this.functionService.callFunction(
            e.itemData.data.action.functionName,
            this.storeService.currentId,
            item
          );
          this.notifier.success('Funkcja zostala wykonana');
          break;
        case 'AssemblyAction':
          const assemblyAction = e.itemData.data.action as AssemblyAction;
          this.functionService.callAssemblyAction(assemblyAction, this.storeService.currentId, item, e.itemData.rowData);
          break;
        case 'CustomDialogAction':
          action.inputParams = { id: this.storeService.currentId };
          this.storeService.setCustomDialogSingleViewContent(action as CustomDialogAction);
          break;
        default:
          this.storeService.currentElementId = e.itemData.data.action.elementId;
          this.storeService.currentElementViewId = e.itemData.data.action.elementViewId;
          this.storeService.setShowGrid(false);
          break;
      }
    }

    if (this.config == null) {
      this.config = this.storeService.getConfiguration();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/context-menu/context-menu.component.ts